module.exports = __webpack_public_path__ + "static/media/with_text.cd1c0d97.png";